import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthServiceZ } from './authentification/auth-service.service';
import * as Feather from 'feather-icons';

declare var $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'front';
  showNAv = true;
  mustLogoutCheckInterval;

  constructor(public router: Router,
              private activeroute: ActivatedRoute,
              private authService: AuthServiceZ

  ) {
    if (
      window.location.href.includes('payment/pay') ||
      window.location.href.includes('payment/deliverySuccess') ||
      window.location.href.includes('payment/deliveryFail')
    ) {
      this.showNAv = false;
    }

  }

  hisOv(){
    console.log("clackkk")
    $("#historybar").get(0).style.setProperty("display", "none");
    $("#historybar").get(0).style.setProperty("z-index", "0");
    $("#his-overlay").get(0).style.setProperty("display", "none");
    $("#his-overlay").get(0).style.setProperty("opacity", "0");
    $("#his-overlay").get(0).style.setProperty("z-index", "0");

    $("body").removeClass("sidebar-noneoverflow");

  }


  setIntervalForLogoutCheck(){
    // if(!this.mustLogoutCheckInterval){
    //   this.mustLogoutCheckInterval = setInterval(() => {
    //     this.authService.mustLogout().then((doLogout) => {
    //       if (doLogout){
    //         this.authService.logout();
    //         this.router.navigate(['/auth/login']);
    //       }
    //     }).catch((e) => {
    //       console.log('err when retrieving user state');
    //     });
    //   }, 1000 * 60 * 2);
    // }
  }

  ngAfterViewInit() {
    Feather.replace();
    // setting interval for testing whether the user needs to logOut or not
    if (this.authService?.credentials?.user?._id){
      //  this.setIntervalForLogoutCheck();
    }else{
      this.authService.loginEvent.subscribe((cdrs) => {
        console.log(cdrs);
        if (cdrs){
          //  this.setIntervalForLogoutCheck();
        }else{
          if (this.mustLogoutCheckInterval){
            //  clearTimeout(this.mustLogoutCheckInterval);
          }
        }
      });
    }

  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    if (this.mustLogoutCheckInterval){
      // clearTimeout(this.mustLogoutCheckInterval);
    }
  }
}
